export default {
  globalLayoutName: {
    company: {
      create: 'Stickyweb Bedrijf aanmaken',
      update: 'Stickyweb Bedrijf detail',
      list: "Stickyweb Bedrijven list",
    },
    person: {
      create: "Stickyweb Persoon aanmaken",
      update: "Stickyweb Persoon detail",
      list: "Stickyweb Personen lijst",
    },
    dashboard: {
      list: "Stickyweb Dashboard",
    },
    invoice: {
      list: "Stickyweb facturatie lijst",
      create: "Stickyweb factuur aanmaken",
      update: "Stickyweb factuur detail",
    }
  },

  operationSelect: {
    title: "Bekijk indelingen voor"
  },

  layoutList: {
    title: "Indelingen",

    noLayoutInList: "Nog geen {{type}} aangemaakt",

    private: "Privé indelingen",
    client: "Systeem indelingen",
    global: "Stickyweb vaste indeling",
  },

  input: {
    title: "Indeling {{action}}",
    name: {
      label: "Naam van de indeling",
    },
    private: {
      label: {
        private: "Privé indeling",
        system: "Systeem indeling",
      }
    },

    tabs: {
      firstTab: "Primair",

      addTab: "Tab toevoegen",
    },
  },

  toolbar: {
    create: "Indeling"
  },

  api: {
    systemLayout: {
      name: {
        notNull: "Geef de indeling een naam",
      },
    },
    systemLayoutTab: {
      name: {
        notNull: "Alle tabs dienen een naam te hebben",
      },
    }
  }
}
